var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type==='title')?_c('p',{staticClass:"title"},[_vm._t("icon"),_c('span',[_vm._v(_vm._s(_vm.text))])],2):_c('a',{staticClass:"subtitle",attrs:{"href":'#'+ _vm.hash}},[_vm._v(_vm._s(_vm.text))])}
var staticRenderFns = []

export { render, staticRenderFns }